import React from 'react';
import { Select, MenuItem, Typography, SelectChangeEvent } from '@mui/material';
import { TipoMarcacion } from '../types';

interface MarcacionDropdownProps {
  tipos: TipoMarcacion[];
  value: number | null;
  onChange: (id: number | null) => void;
  onMarcacionSelect?: (tipoId: number | null) => void;
  disabled?: boolean;
}

const NONE_VALUE = '__none__';

export function MarcacionDropdown({ tipos, value, onChange, onMarcacionSelect, disabled = false }: MarcacionDropdownProps) {
  // RN-001: la selección de un tipo se dispara por el onClick propio de cada MenuItem
  // (ver abajo), no por este onChange — MUI no dispara onChange cuando el valor
  // seleccionado ya es el activo. "Sin marcación" sigue usando onChange normal.
  const handleChange = (e: SelectChangeEvent<string>) => {
    const v = e.target.value;
    if (v === NONE_VALUE) {
      onChange(null);
    }
  };

  const handleTipoClick = (tipoId: number) => {
    if (onMarcacionSelect) {
      onMarcacionSelect(tipoId);
    } else {
      onChange(tipoId);
    }
  };

  if (tipos.length === 0) {
    return (
      <Typography sx={{ color: '#8E8994', fontSize: '16px' }}>
        Sin opciones
      </Typography>
    );
  }

  return (
    <Select
      value={value !== null ? String(value) : NONE_VALUE}
      onChange={handleChange}
      disabled={disabled}
      sx={{
        height: '56px',
        fontSize: '16px',
        borderRadius: '6px',
        '& .MuiOutlinedInput-notchedOutline': { borderColor: '#DFDCE2' },
        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#9B2B9D' },
        '& .MuiSelect-select': { py: 0, px: '14px', display: 'flex', alignItems: 'center' },
        width: '100%',
      }}
    >
      <MenuItem value={NONE_VALUE}>
        <Typography sx={{ fontSize: '16px', color: '#A09AA5' }}>Sin marcación</Typography>
      </MenuItem>
      {tipos.map((t) => (
        <MenuItem key={t.id} value={String(t.id)} onClick={() => handleTipoClick(t.id)}>
          <Typography sx={{ fontSize: '16px' }}>{t.nombre}</Typography>
        </MenuItem>
      ))}
    </Select>
  );
}
